// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'offer-list';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M.563 10.687v6.75m0-1.125h11.25a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25-2.25H.562m3.938 2.25h2.25m6.563.001h3.374a.75.75 0 0 0 .75-.75v-12a.75.75 0 0 0-.75-.75H7.313a.75.75 0 0 0-.75.75v8.25m5.625-5.469H15m-2.812 3H15m-2.812 3H15m-5.437-6h.374m-.374 3h.374m-.374 3h.374'
  />
);

export const viewBox = '0 0 18 18';
